<template>
      <div id="summary">
            <section class="section summary-hero animate__animated animate__fadeIn">
                  <BackButton link="/benefits" color="white" />
                  <div class="summary-content">
                        <h1>You&rsquo;re almost done</h1>
                        <p class="summary-subtitle">Thanks for taking the time to go through these steps to determine the best plan for you.</p>
                        <p class="summary-desc">Now that you know your suggested Anthem plan, you can download/email the suggested plan name as a reminder, or go directly to <a href="https://myshbpga.adp.com/" target="_blank" @click="track('Link','myshbpga.adp.com - Summary')">https://myshbpga.adp.com/</a> to enroll during this year&rsquo;s open enrollment selection period, October 19 through November 6, 2026.</p>
                  </div>
                  <div class="summary-btn-wrap">
                        <button type="button" class="summary-btn" @click="checkDate()"><span>Enroll</span></button>
                        <a :href="planDownload" target="_blank" class="summary-btn" @click="track('CTA','Download OE Guide - Summary')"><span>Download</span></a>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPSummary",
            data (){
                  return{
                        planSelect: this.$store.state.planSelect,
                        linkCheck: "My VAR Test",
                        getStartedURL:"https://myshbpga.adp.com/",
                        planDownload:"",
                        popMessage: "<h5 style='font-weight:600;font-size: 1.125rem;margin-bottom:8px !important;'>Open Enrollment starts October 19, 2026</h5> <p style='margin-bottom:8px !important;'>You can't enroll in your suggested plan yet, but go to <a href='https://myshbpga.adp.com' target='_blank' id='popLink' @click='method'>myshbpga.adp.com</a>  to review your suggested plan costs. You'll also find additional information and valuable resources about how to get the most out of your plan options. Be sure to come back, starting October 19, 2026 to enroll in your suggested plan.</p>"
                  }
            },
            methods: {
                  checkDate(){
                        let enrollDate = "2026-10-19",
                              currentDate = new Date()
                        enrollDate = new Date(enrollDate)
                        if(enrollDate > currentDate){
                              this.$swal({
                                    html: this.popMessage,
                                    showCancelButton: false
                              })
                              this.track("CTA", "No Open Enrollment - Summary")
                        }
                        else{
                              this.track("CTA", "Yes Open Enrollment - Summary")
                              window.open( this.getStartedURL, "_blank")
                        }
                  },
                  download(){
                        let planSelect = this.planSelect
                        if(planSelect=="HMO") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Gold") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Silver") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Bronze") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else this.planDownload =  "/docs/OE-Guide-27.pdf"
                  },
                  someMethod(e) {
                        e.preventDefault();
                        this.track("Link", "myshbpga.adp.com - Pop Up Window - Summary")
                        window.open( this.getStartedURL, "_blank")
                  }
            },
            beforeMount(){
                  this.download()
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
      #summary{
            .summary-hero{
                  background-color: #1355E9;
                  margin-top: 68px;
                  min-height: calc(100vh - 68px);
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 120px 24px 160px 24px;
                  position: relative;

                  .back-btn{
                        top: 40px;
                        left: 86px;
                  }
            }

            .summary-content{
                  max-width: 640px;
                  margin: 0 auto;
                  text-align: center;

                  h1{
                        color: #ffffff;
                        font-size: clamp(2.75rem, 5vw, 4.5rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .summary-subtitle{
                        color: #ffffff;
                        font-size: 1.125rem;
                        font-weight: 600;
                        line-height: 1.4;
                        max-width: 480px;
                        margin: 0 auto 40px auto;
                  }

                  .summary-desc{
                        color: rgba(255, 255, 255, 0.85);
                        font-size: 0.9375rem;
                        line-height: 1.6;
                        max-width: 460px;
                        margin: 0 auto;

                        a{
                              color: #ffffff !important;
                              font-weight: 700;
                              text-decoration: underline;
                        }
                  }
            }

            .summary-btn-wrap{
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  padding: 32px 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 24px;
            }

            .summary-btn{
                  display: block;
                  background-color: #ffffff;
                  color: #1355E9 !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 280px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;

                  &:hover{
                        opacity: 0.85;
                  }
            }

            @media only screen and (max-width: 640px){
                  .summary-hero{
                        padding: 96px 24px 40px 24px;

                        .back-btn{
                              top: 20px;
                              left: 2rem;
                        }
                  }

                  .summary-content{
                        h1{
                              font-size: clamp(2rem, 9vw, 3.25rem) !important;
                        }

                        .summary-subtitle{
                              margin-bottom: 32px;
                        }
                  }

                  .summary-btn-wrap{
                        position: static;
                        flex-direction: column;
                        gap: 16px;
                        padding: 40px 0 0 0;
                  }

                  .summary-btn{
                        max-width: 100%;
                  }
            }
      }
</style>
